import { useLang } from "@/lib/i18n";
import Icon from "@/components/shared/Icon";

const STYLES = {
  Planned: { cls: "bg-blue-50 text-blue-700 border-blue-200", icon: "CalendarClock", zh: "计划中" },
  "Awaiting verification": { cls: "bg-amber-50 text-amber-700 border-amber-200", icon: "ShieldQuestion", zh: "待核实" },
  Pending: { cls: "bg-purple-50 text-purple-700 border-purple-200", icon: "Hourglass", zh: "待处理" },
  Confirmed: { cls: "bg-emerald-50 text-emerald-700 border-emerald-200", icon: "BadgeCheck", zh: "已确认" },
  Failed: { cls: "bg-rose-50 text-rose-700 border-rose-200", icon: "XCircle", zh: "失败" },
};

export default function StatusBadge({ status }) {
  const { code } = useLang();
  const s = STYLES[status] || STYLES.Planned;
  const label = code === "zh" ? s.zh : status;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-bold ${s.cls}`}
      data-testid={`status-badge-${status.replace(/\s+/g, "-").toLowerCase()}`}
    >
      <Icon name={s.icon} className="h-3.5 w-3.5" />
      {label}
    </span>
  );
}
